import { NetworkRequestState, RequestMeta } from '../networking/types';
import { PapiRequestDaSharedUserSendotp } from '@wix/da-papi-types';
import { OneTimePasswordStoreSlice } from './types';

const initialRequestMeta: RequestMeta<PapiRequestDaSharedUserSendotp> = {
  status: NetworkRequestState.IDLE,
  errors: {},
};

export const defaultOneTimePasswordState: OneTimePasswordStoreSlice = {
  request: initialRequestMeta,
  requestCount: 0,
};
